export function checkForStories(link) {
    const stories = link.match(/(?:instagram\.com|instagr\.am)\/stories\/([A-Za-z0-9-_\.]+)\/([A-Za-z0-9-_\.]+)/im)
    const highlights = link.match(/(?:instagram\.com|instagr\.am)\/stories\/highlights\/([A-Za-z0-9-_\.]+)/im)
    return !!(stories || highlights)
}
export function checkForReels(link) {
    const reels = link.match(/(?:instagram\.com|instagr\.am)\/reel[s]?\/([A-Za-z0-9-_\.]+)/im)
    return !!reels
}
export function checkForPosts(input) {
    const posts = input.match(/^(https:\/\/|http:\/\/)?(www\.)?(instagram\.(com|org)|instagr\.am)(\/(p|tv))/gims)
    if (posts) {
        return true
    }
}

export function isProfileLink(input){
    const profile = input.match(/(?:instagram\.com|instagr\.am)\/([A-Za-z0-9-_\.]+)\/?$/gim)
    return !!profile
}

// Единый предикат «ввод адресует профиль инстаграма»: ссылка на профиль или ник @username.
// SearchForm маршрутизирует по нему, SearchResults по нему же решает, что умеет обработать —
// иначе расхождение предикатов даёт молчаливый выход без результата и без ошибки.
export function isProfileQuery(input = ''){
    return input[0] === '@' || isProfileLink(input)
}

export function isInstagramContent(input){
    return checkForPosts(input) || checkForReels(input) || checkForStories(input)
}

export function isInstagramPage(){
    return window?.location.pathname?.includes('instagram') || window?.location?.href.includes('instagram')
}

export function isInstagramContext(string = ''){
    // Регистронезависимо и с instagr.am — чтобы совпадать с isProfileLink,
    // который матчит оба домена с флагом 'i'.
    return isInstagramPage() || /instagram\.com|instagr\.am/i.test(string)
}
